import { Loader } from '@googlemaps/js-api-loader';

document.addEventListener("DOMContentLoaded", function () {

	//check if container of the entity map exists
	const htmlMapContainer = document.getElementById("entity-map");
  
	if (htmlMapContainer) { 
  //add intersection detection
    initMapIntersectionDetection(htmlMapContainer);
	}
}
);

const loader = new Loader({
    // wijkinfoquartier@gmail.com
	  apiKey: "AIzaSyAPKS32SA1mgtDBywdO2wC6PCV57aZy3AM",
    version: "weekly",
    libraries: ["maps", "marker"],
    language: document.documentElement.lang.substring(0, 2)
});

const mapOptions = {
  //Belgium location centre
    center: {
        lng: 50.863368980032476,
        lat: 4.366786948972418
    },
	mapId: "c7b62ba34135e5f6",
    //Belgium location centre
    center: { lat: 50.5991475, lng: 4.3915917},
    zoom: 13,
    scrollwheel: false,
    mapTypeControl: false,
    zoomControl: true,
    scaleControl: false,
    streetViewControl: false,
    fullscreenControl: false,
};

const loadPartnersGoogleMap = ( htmlMapContainer, entityLocation ) =>{

    loader.load()
    .then((google) => {
		const map = new google.maps.Map(htmlMapContainer, mapOptions );
		
		const parser = new DOMParser();
// A marker with a custom inline SVG.
const pinSvgString = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="70" viewBox="0 0 49.29 70"><path d="M24.4 69s-.1-.01-.14-.02c.05.01.1.01.14.02zm.24.03s.09 0 .13-.01h-.18.05zm-.58-.11s-.09-.03-.13-.05c.04.02.09.03.13.05zm-.33-.16s-.07-.04-.1-.06c.03.02.07.04.1.06zm1.37.2c-.06.02-.12.03-.19.04.06 0 .13-.03.19-.04zM24.63.97c.21 0 .43.01.64.02-.21 0-.42-.02-.63-.02zm.79 67.87c-.06.03-.13.07-.2.09.07-.02.13-.06.2-.09zm11.64-14.63c-.64.95-1.27 1.87-1.91 2.76.63-.89 1.27-1.81 1.91-2.76zM25.79 68.59c-.09.08-.18.14-.27.2.09-.06.19-.12.27-.2zm6.58-7.85zM25.85 1c.2 0 .39.03.59.04-.2-.01-.39-.03-.59-.04zm4.7.71s.05.02.08.02c-.03 0-.06-.02-.08-.02zm-3.5-.62c.19.02.38.05.57.07-.19-.02-.38-.05-.57-.07zm-1.26 67.5l.12-.12c1.07-1.18 2.75-3.08 4.71-5.51a114.82 114.82 0 01-4.71 5.51l-.12.12zM29.4 1.45c.07.01.14.03.21.05-.07-.01-.14-.03-.21-.05zm-1.17-.21c.16.02.31.06.47.08-.16-.03-.31-.06-.47-.08z" fill="none"/><path d="M30.63 1.74s-.05-.02-.08-.02c-.31-.08-.62-.15-.94-.22-.07-.01-.14-.03-.21-.05-.23-.05-.47-.08-.7-.12-.16-.03-.31-.06-.47-.08-.2-.03-.41-.05-.61-.08-.19-.02-.38-.05-.57-.07-.2-.02-.41-.03-.61-.05-.2-.01-.39-.03-.59-.04-.19 0-.39 0-.58-.01-.21 0-.42-.02-.64-.02-.61 0-1.21.02-1.81.07-.6.05-1.21.12-1.8.21-.55.09-1.09.19-1.62.32-3.75.87-7.23 2.64-10.15 5.16-.7.6-1.36 1.21-1.96 1.84-.6.63-1.16 1.27-1.67 1.93-.51.66-.97 1.32-1.39 2.01a21.588 21.588 0 00-2.85 7.52c-.07.37-.13.75-.18 1.12-.1.75-.16 1.51-.2 2.27-.02.38-.02.76-.02 1.15 0 2.69.39 5.43 1.07 8.17.29 1.17.63 2.35 1.02 3.51.26.78.54 1.55.83 2.32.44 1.16.93 2.31 1.45 3.44.69 1.51 1.43 3.01 2.22 4.46.2.36.39.73.6 1.09 1 1.8 2.06 3.54 3.13 5.21.21.33.43.66.65.99 1.08 1.63 2.17 3.19 3.23 4.63.64.87 1.26 1.7 1.88 2.49.61.79 1.2 1.54 1.77 2.24.19.23.38.46.56.69.37.45.72.87 1.06 1.28 1.19 1.41 2.2 2.55 2.94 3.36.08.09.17.17.27.24.03.02.07.04.1.06.07.04.13.08.2.11.04.02.09.03.13.05.06.02.13.05.2.06.05.01.1.01.14.02.06 0 .13.02.19.02h.18c.04 0 .09 0 .13-.01.06 0 .13-.03.19-.04l.12-.03c.07-.02.13-.06.2-.09.03-.02.07-.03.1-.05.09-.06.19-.12.27-.2l.12-.12a125.875 125.875 0 006.46-7.73c.9-1.17 1.84-2.43 2.79-3.76.63-.89 1.27-1.81 1.91-2.76.95-1.43 1.9-2.92 2.82-4.47 1.53-2.57 2.98-5.29 4.23-8.08.25-.56.49-1.12.73-1.68 2.1-5.07 3.48-10.34 3.48-15.43 0-10.96-7.51-20.17-17.68-22.82zm4.71 35.73a16.784 16.784 0 01-10.69 3.83c-1.16 0-2.29-.12-3.39-.34a16.896 16.896 0 01-6.01-2.52 16.891 16.891 0 01-5.39-5.91c-1.3-2.37-2.03-5.09-2.03-7.98s.74-5.6 2.03-7.98c1.3-2.37 3.15-4.4 5.39-5.91.45-.3.91-.58 1.39-.84a16.69 16.69 0 014.62-1.68c1.09-.22 2.23-.34 3.39-.34 4.06 0 7.78 1.44 10.69 3.83 3.74 3.07 6.13 7.72 6.13 12.92s-2.39 9.84-6.13 12.92z" fill="#244069"/><path d="M24.63 0c-1.26 0-2.52.1-3.77.29-4.55.73-8.79 2.7-12.26 5.7C3.36 10.45.48 16.1.06 22.78c-1.19 18.68 16.99 40.19 22.59 46.33.51.56 1.24.89 2 .89a2.68 2.68 0 001.98-.87c5.32-5.83 22.66-26.28 22.66-44.57C49.29 11.02 38.23 0 24.63 0zm19.48 41.67c-1.25 2.79-2.7 5.51-4.23 8.08-.92 1.54-1.87 3.04-2.82 4.47-.64.95-1.27 1.87-1.91 2.76-.95 1.33-1.89 2.59-2.79 3.76-.6.78-1.19 1.52-1.75 2.22a114.82 114.82 0 01-4.71 5.51l-.12.12c-.09.08-.18.14-.27.2-.03.02-.07.03-.1.05-.06.03-.13.07-.2.09l-.12.03c-.06.02-.12.03-.19.04-.04 0-.09 0-.13.01-.04 0-.09.01-.13.01h-.05c-.07 0-.13-.01-.19-.02a.59.59 0 01-.14-.02l-.2-.06c-.04-.02-.09-.03-.13-.05-.07-.03-.14-.07-.2-.11-.03-.02-.07-.04-.1-.06-.1-.07-.19-.15-.27-.24-.73-.81-1.74-1.94-2.94-3.36-.34-.4-.69-.83-1.06-1.28-.18-.22-.37-.45-.56-.69a133.69 133.69 0 01-3.65-4.73c-1.06-1.45-2.15-3-3.23-4.63-.22-.33-.43-.66-.65-.99a97.01 97.01 0 01-3.13-5.21c-.2-.36-.4-.72-.6-1.09a80.46 80.46 0 01-2.22-4.46c-.52-1.14-1-2.29-1.45-3.44-.3-.77-.58-1.55-.83-2.32-.39-1.17-.73-2.34-1.02-3.51-.68-2.74-1.06-5.48-1.07-8.17 0-.38 0-.77.02-1.15a24.529 24.529 0 01.38-3.39c.47-2.61 1.39-5.14 2.85-7.52.42-.68.88-1.35 1.39-2.01.51-.66 1.06-1.3 1.67-1.93.6-.63 1.26-1.24 1.96-1.84 2.92-2.52 6.41-4.29 10.15-5.16.54-.12 1.08-.23 1.62-.32.6-.09 1.2-.16 1.8-.21C23.39 1 24 .98 24.6.98c.21 0 .42.01.63.02.19 0 .39 0 .58.01.2 0 .39.03.59.04.21.02.41.03.61.05.19.02.38.05.57.07.2.03.41.05.61.08.16.02.31.06.47.08l.7.12c.07.01.14.03.21.05.31.07.63.14.94.22.03 0 .05.02.08.02C40.76 4.39 48.27 13.6 48.27 24.56c0 5.08-1.38 10.36-3.48 15.43-.23.56-.48 1.12-.73 1.68z" fill="#fff"/><path d="M35.34 11.64a16.784 16.784 0 00-10.69-3.83c-1.16 0-2.29.12-3.39.34a16.896 16.896 0 00-6.01 2.52 16.891 16.891 0 00-5.39 5.91c-1.3 2.37-2.03 5.09-2.03 7.98s.74 5.6 2.03 7.98c1.3 2.37 3.15 4.4 5.39 5.91.45.3.91.58 1.39.84 1.43.77 2.98 1.35 4.62 1.68 1.09.22 2.23.34 3.39.34 4.06 0 7.78-1.44 10.69-3.83 3.74-3.07 6.13-7.72 6.13-12.92s-2.39-9.84-6.13-12.92zM15.59 28.36c-.5-1.17-.77-2.46-.77-3.81 0-5.4 4.41-9.79 9.83-9.79s9.83 4.39 9.83 9.79c0 1.35-.28 2.64-.77 3.81a9.857 9.857 0 01-9.06 5.98c-1.35 0-2.65-.27-3.82-.77a9.891 9.891 0 01-5.24-5.21z" fill="#fff"/><path d="M28.47 33.58a9.891 9.891 0 005.24-5.21c.5-1.17.77-2.46.77-3.81 0-5.4-4.41-9.79-9.83-9.79s-9.83 4.39-9.83 9.79c0 1.35.28 2.64.77 3.81a9.857 9.857 0 009.06 5.98c1.35 0 2.65-.27 3.82-.77z" fill="#c2ca28"/></svg>`;
const pinSvg = parser.parseFromString(
  pinSvgString,
  "image/svg+xml",
).documentElement;

		map.setCenter(entityLocation);
    })
    .catch(e => {
      // do something
      console.error("something went wrong", e);
    });
}

const callbackMapDetection = (entries, observer) => {

  const isMapLoaded =  (typeof google === 'object' && typeof google.maps === 'object') ;
	const htmlMapContainer = document.getElementById("entity-map");

	// isIntersecting
	entries.forEach((entry) => {

	  // Each entry describes an intersection change for one observed
	  if (entry.isIntersecting && !isMapLoaded) {

      const htmlLat = document.getElementById("entity-lat");
      const htmlLng = document.getElementById("entity-lng");
        loadPartnersGoogleMap( htmlMapContainer, {
          lat: +htmlLat.value,
          lng: +htmlLng.value
        } ); 

	  } else {

	  }
	});
  };

const initMapIntersectionDetection = (target)=>{

  if(target){
		const options = {
			root: null,
			rootMargin: "0px",
			threshold: 0.3,
		};
		
		const observer = new IntersectionObserver(callbackMapDetection, options);
		observer.observe(target);
	}
}